<template>
    <dropdown
        data-testid="header-dropdown-account"
        :key="isMobile"
        v-c-tooltip="{
            content: trans('navigation.profile'),
            placement: 'bottom',
            trigger: isMobile ? ['none'] : ['hover'],
        }"
        toggler-classes="px-[5px]"
        :caret="false"
        variant="nav-item"
    >
        <template #toggler>
            <div class="flex size-8 shrink-0 items-center justify-center rounded-full bg-white p-0 leading-8">
                <span class="font-bold text-black">{{ userInitials }}</span>
            </div>
        </template>
        <dropdown-item :href="$route('profile.show')" @click="router.visit($route('profile.show'))">
            {{ trans('navigation.profile') }}
        </dropdown-item>
        <dropdown-divider />
        <dropdown-item @click="logout">
            <span class="flex items-center justify-between gap-2 whitespace-nowrap">
                {{ trans('navigation.logout') }}
                <logout-icon />
            </span>
        </dropdown-item>
    </dropdown>
</template>

<script setup>
import Dropdown from '@/Components/Dropdown.vue';
import DropdownItem from '@/Components/DropdownItem.vue';
import { router, usePage } from '@inertiajs/vue3';
import DropdownDivider from '@/Components/DropdownDivider.vue';
import LogoutIcon from '../../icons/LogoutIcon.vue';
import { computed } from 'vue';
import { isMobile } from '@/Utils/UseMedia';

const logout = () => router.post(route('logout'));

const userInitials = computed(() => {
    const user = usePage().props.auth.user;
    if (!user) {
        return '';
    }
    return (user.firstName[0] + user.lastName[0]).toUpperCase();
});
</script>
